import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

export const useGetActiveSubmissions = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery(
    ["activeSubmissions"],
    async () => {
      const token = await getAccessTokenSilently();
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/events/active-submissions-summary`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data;
    },
    {
      enabled: false, // Only fetch when explicitly called
      refetchOnWindowFocus: false,
    }
  );
};
